/**
 * Converts a phone number string into a 'tel:' href in E.164 format.
 *
 * @param phoneNumber The raw phone number string (e.g. "1-844-844-8040, TTY 711").
 * @returns a string (e.g. "tel:+18448448040"), or null if no digits found.
 */
export function buildTelToHref(phoneNumber) {
    if (!phoneNumber) return null;
    const s = String(phoneNumber);
  
    const [mainPart] = s.split(/(?:,|\bTTY\b)/i);
    const digits = mainPart.replace(/\D/g, '');
    if (!digits) return null;

    // Normalize to E.164
    const e164 =
        digits.length === 10 ? `+1${digits}` :
            digits.length === 11 && digits.startsWith('1') ? `+${digits}` :
                `+${digits}`;

    return `tel:${e164}`;
}